module.exports = __webpack_public_path__ + "img/6_24.4156e7ef.png";